"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultPassHandler = void 0;
const defaultPassHandler = (form) => {
    return form.stats.qualified === form.stats.valid;
};
exports.defaultPassHandler = defaultPassHandler;
